
// fundReducer
 export const SET_FUND_LOADER= 'SET_FUND_LOADER';
 export const FETCH_FUND_DATA= 'FETCH_FUND_DATA';
 export const FETCH_BASIC_FUND_DATA= 'FETCH_BASIC_FUND_DATA';
 export const SET_FUND_INFO_DATA= 'SET_FUND_INFO_DATA';
 export const SET_BASIC_FUND_INFO_DATA= 'SET_BASIC_FUND_INFO_DATA';
 export const SET_MEMBERS_TRUSTEES_DATA= 'SET_MEMBERS_TRUSTEES_DATA';
 export const SET_COMPANY_DETAILS_DATA= 'SET_COMPANY_DETAILS_DATA';